import { render, staticRenderFns } from "./xmlEditor.vue?vue&type=template&id=2d164001&scoped=true&"
import script from "./xmlEditor.vue?vue&type=script&lang=js&"
export * from "./xmlEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d164001",
  null
  
)

export default component.exports